import React, { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { GET_ZONE_SCHEME_BY_EXERCISE } from "../../api/apiRoutes";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import { ZoneSeats } from "../../models/ZoneSeats";
import useApiRequest from "../../utils/hook/useApiRequest";
import { useSelector } from "react-redux";
import { State } from "../../store";
import qs from "qs";
import { useLocation } from "react-router";
import getObjectIds from "../../utils/getObjectIds";
import getId from "../../utils/getId";
import { retStatusSeat, seatIsInBasket, seatIsNoAvailable } from "./SeatsView/RoomSchame";
import SeatView from "./SeatsView/SeatView";
import { RowZone } from "../../models/RowZone";
import { Seat } from "../../models/Seat";

interface IProps {
  onSelectSeat: (rowZone: RowZone, seat: Seat) => void;
  selectedSeat: Seat;
}

const minLeft = "-415px";
const maxLeft = "150px";

const MiniRoomSchame: React.FC<IProps> = ({ onSelectSeat, selectedSeat }: IProps) => {
  const { post } = useApiRequest();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [zoneScheme, setZoneScheme] = useState<ZoneSeats | null>(null);
  const selectExercise = useSelector((state: State) => state.basket.exerciseSelect);
  const exerciseIds = qs.parse(location.search.slice(1)).exerciseIds as string;
  const basket = useSelector((state: State) => state.basket.basket);
  const [positionLeft, setPositionLeft] = useState(minLeft);

  const getZoneScheme = async () => {
    setLoading(true);
    const objectIds = getObjectIds(exerciseIds !== undefined ? exerciseIds : getId(selectExercise[0]));
    const { result, isError } = await post(GET_ZONE_SCHEME_BY_EXERCISE, {
      exerciseDb: objectIds?.objectDb,
      exerciseId: objectIds?.objectId
    });

    if (!isError) {
      // setZoneScheme(result);
      checkSelectedSeat(result);
    }

    setLoading(false);
  };

  const calculateDistanceToNext = zoneScheme?.rowZones?.map(scheme => {
    let distance = 0;
    return {
      ...scheme,
      seats: scheme.seats.map(seat => {
        distance += seat.distanceToNext;
        return {
          ...seat,
          distanceToNext: seat.distanceToNext,
          status: seatIsInBasket(seat, basket) ? "W" : seat.status
        };
      })
    };
  });

  const checkSelectedSeat = (zoneScheme: ZoneSeats) => {
    let zones = null;
    if (zoneScheme) {
      zones = {
        ...zoneScheme,
        rowZones: zoneScheme.rowZones?.map(scheme => {
          return {
            ...scheme,
            seats: scheme.seats.map(seat => {
              return {
                ...seat,
                status: getId(seat) === getId(selectedSeat) ? "W" : seat.status
              };
            })
          };
        })
      };
    }
    setZoneScheme(zones);
  };

  const handleSeeZoneScheme = () => {
    if (positionLeft === minLeft) {
      setPositionLeft(maxLeft);
    } else {
      setPositionLeft(minLeft);
    }
  };

  useEffect(() => {
    getZoneScheme();
  }, []);

  return (
    <>
      <Box
        style={{
          position: "fixed",
          width: "600px",
          height: "250px",
          border: `1px solid #cf5023`,
          top: "250px",
          left: positionLeft,
          backgroundColor: "#fff",
          transition: ".7s",
          borderTopRightRadius: 14,
          borderBottomRightRadius: 14,
        }}
      >
        <LoadableComponent loading={loading}>
          <Box style={{ transform: `scale(${0.4})`, position: "absolute", top: "-17%", left: "-10%"}}>
            {calculateDistanceToNext === undefined || calculateDistanceToNext.length === 0 ? (
              <Typography>Brak danych</Typography>
            ) : (
              calculateDistanceToNext.map((item, index) => (
                <React.Fragment key={index}>
                  {item.seats.map((seat, indexS) => (
                    <div
                      key={`${index}${indexS}`}
                      onClick={
                        seatIsNoAvailable(seat.status ?? "")
                          ? () => {}
                          : () => {
                              onSelectSeat(item.rowZone, seat);
                            }
                      }
                    >
                      <SeatView
                        title={seat.name}
                        top={seat.y}
                        left={seat.x}
                        height={seat.height}
                        width={seat.width}
                        shape={seat.shape}
                        pictureUrl={seat.picture_url}
                        rotation={seat.rotation}
                        colorClass={retStatusSeat(seat.status ?? "noAvailable")}
                        status={seat.status ?? ""}
                        textTooltip={seat.description}
                      />
                    </div>
                  ))}
                </React.Fragment>
              ))
            )}
          </Box>
        </LoadableComponent>
        <div
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            width: 35,
            height: "250px",
            backgroundColor: "#cf5023",
            color: "#fff",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            borderTopRightRadius: 14,
            borderBottomRightRadius: 14
          }}
          onClick={() => handleSeeZoneScheme()}
        >
          <div style={{ transform: "rotate(-90deg)", transformOrigin: "center" }}>
            Podgląd hali
          </div>
        </div>
      </Box>
    </>
  );
};

export default MiniRoomSchame;
